import { render, staticRenderFns } from "./updatepayplan.vue?vue&type=template&id=35e9a8f5&"
import script from "./updatepayplan.vue?vue&type=script&lang=js&"
export * from "./updatepayplan.vue?vue&type=script&lang=js&"
import style0 from "./updatepayplan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports